var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgForums = function SvgForums(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_398_7108)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5846 10.8333C12.5721 10.8333 11.7513 11.6541 11.7513 12.6667V19.9167C11.7513 20.9292 12.5721 21.75 13.5846 21.75H14.3748C14.8811 21.75 15.2915 22.1604 15.2915 22.6667V23.5428L17.188 21.9625C17.3527 21.8252 17.5603 21.75 17.7748 21.75H23.668C24.6805 21.75 25.5013 20.9292 25.5013 19.9167V12.6667C25.5013 11.6541 24.6805 10.8333 23.668 10.8333H13.5846ZM9.91797 12.6667C9.91797 10.6416 11.5596 9 13.5846 9H23.668C25.693 9 27.3346 10.6416 27.3346 12.6667V19.9167C27.3346 21.9417 25.693 23.5833 23.668 23.5833H18.1067L14.9617 26.2042C14.6884 26.4319 14.3081 26.4809 13.986 26.3301C13.6639 26.1792 13.4582 25.8556 13.4582 25.5V23.5812C11.4917 23.5145 9.91797 21.8994 9.91797 19.9167V12.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9868 17.2501C27.9868 16.997 28.192 16.7917 28.4451 16.7917C29.6023 16.7917 30.5404 17.7298 30.5404 18.887V24.7798C30.5404 26.0455 29.5143 27.0715 28.2487 27.0715H27.5939C27.3408 27.0715 27.1356 27.2767 27.1356 27.5298V30.0834C27.1356 30.264 27.0296 30.4277 26.8648 30.5016C26.7 30.5755 26.5072 30.5458 26.3724 30.4257L22.7372 27.1876C22.6533 27.1128 22.5448 27.0715 22.4324 27.0715H19.8023C18.6451 27.0715 17.707 26.1334 17.707 24.9763C17.707 24.7231 17.9122 24.5179 18.1654 24.5179C18.4185 24.5179 18.6237 24.7231 18.6237 24.9763C18.6237 25.6272 19.1514 26.1548 19.8023 26.1548H22.4324C22.7696 26.1548 23.0951 26.2788 23.3469 26.5031L26.2189 29.0614V27.5298C26.2189 26.7705 26.8345 26.1548 27.5939 26.1548H28.2487C29.0081 26.1548 29.6237 25.5392 29.6237 24.7798V18.887C29.6237 18.2361 29.096 17.7084 28.4451 17.7084C28.192 17.7084 27.9868 17.5032 27.9868 17.2501Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_398_7108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(9 9)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgForums);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/forums.0fe8f881c53e877c77bb7f8a82e3e48d.svg";